import { BehaviorSubject, distinctUntilChanged, map, Observable, of } from 'rxjs';

import { Injectable } from '@angular/core';
import { IUserExperience } from '../services';
import { SummitDisposing } from './summit-disposing';

interface ScreenSize {
  width: number;
  height: number;
}
@Injectable()
export class SummitUserExperienceService<T extends IUserExperience> extends SummitDisposing {
  protected currentUserExperienceSubject: BehaviorSubject<T | undefined> = new BehaviorSubject<T | undefined>(
    undefined
  );
  public currentUserExperience: Observable<T | undefined> = this.currentUserExperienceSubject.asObservable();
  protected screenSizeBS: BehaviorSubject<ScreenSize> = new BehaviorSubject<ScreenSize>({
    width: window.innerWidth,
    height: window.innerHeight
  });
  public screenSize$: Observable<ScreenSize> = this.screenSizeBS.asObservable();
  public screenSize = this.screenSizeBS
    .asObservable()
    .pipe(
      distinctUntilChanged((previous, current) => previous.height == current.height && current.width == previous.width)
    );
  protected deferredPrompt: any = null;
  public theme$?: Observable<string>;
  public get$(key: keyof IUserExperience): Observable<IUserExperience[keyof IUserExperience]> {
    return this.currentUserExperience.pipe(map((ux) => (ux as any)[key]));
  }
  public getUserExperience(): IUserExperience {
    return this.currentUserExperienceSubject?.value as unknown as IUserExperience;
  }
  public get isMobile(): Observable<boolean> {
    return of(false);
  }
  refresh() {
    return;
  }
}
